import React from 'react';
import Lottie from 'react-lottie';
import {motion} from "framer-motion";

export default function LottieAnimation({lotti}) {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: lotti,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    }

    return (
        <motion.div
            whileInView={{scale: [0, 1]}}
            transition={{duration: 1, ease: 'easeInOut'}}
        >
            <Lottie className="lottie__animation" options={defaultOptions}/>
        </motion.div>
    )
}